import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
	rus: (
		`
		<div class="poem">
			<p class="poem-block text-center mb-3">1</p>
			
			<p class="poem-block mb-5">
				Раз водитель из города Ясски<br/>
				Наблюдал сумасшедшие пляски.<br/>
				Содрогалась земля,<br/>
				Только было всё зря:<br/>
				Не согреться без шубы в Аляске!
			</p> 
			
			
			<p class="poem-block text-center mb-3">2</p>
			
			<p class="poem-block mb-5">
				Виноградарь из штата Айова<br/>
				Пил вино своё снова и снова.<br/>
				Пей-не пей, – всё равно<br/>
				Не вино, а г…но…<br/>
				Стал хануриком с горя такого.
			</p>
			
			
			<p class="poem-block text-center mb-3">3</p>
			
			<p class="poem-block mb-5">
				Белокурый пират из Бомбея<br/>
				Грабил судно, своих не жалея.<br/>
				Вдруг раздёрнулась снасть,<br/>
				Должен был он упасть:<br/>
				Покарала Фортуна злодея!
			</p>
			
			
			<p class="poem-block text-center mb-3">4</p>
			
			<p class="poem-block mb-5">
				Одна тётя из города Сожа<br/>
				С обезьяной была очень схожа.<br/>
				Раз пошла в зоопарк,<br/>
				И горилле Сан-Марк<br/>
				Её очень понравилась рожа.
			</p>
			
			
			<p class="poem-block text-center mb-3">5</p>
			
			<p class="poem-block mb-5">
				Как один голубой голубочек<br/>
				Стал отцом 18-ти дочек.<br/>
				Долго сам удивлялся,<br/>
				Как он им оказался:<br/>
				Было много, видать, тёмных ночек.
			</p>
			
			
			<p class="poem-block text-center mb-3">6</p>
			
			<p class="poem-block mb-5">
				Раз гражданка из штата Флорида<br/>
				Допилась до скотинного вида.<br/>
				Еле в стойло вползла,<br/>
				Где стоят два козла…<br/>
				Появились потом два гибрида.
			</p>
			
			
			<p class="poem-block text-center mb-3">7</p>
			
			<p class="poem-block mb-5">
				Один лысый старик из Одессы<br/>
				Стал на лысину ставить компрессы.<br/>
				Плешь тотчас заросла.<br/>
				Вот какие дела<br/>
				С нами делают частые стрессы.
			</p>
			
			
			<p class="poem-block text-center mb-3">8</p>
			
			<p class="poem-block mb-5">
				Один толстячок из Австралии<br/>
				Полюбил голубые азалии.<br/>
				Он от этого чуда<br/>
				Похудел на два пуда<br/>
				И видна стала линия талии.
			</p>
		</div>
		`
	)
}

const itemName = {
	rus: 'Лимерики'
}

const item = {
	itemlink: getLink(itemName.rus),
	rus:{
		itemName: itemName.rus,
		itemContent: content.rus,
		itemAuthor: author.rus
	}
}


export default item;